<ng-container [formGroup]="porcionesForm">
    <td [ngClass]="{'show-error': showError}">
        <app-filterable-list class="shorter-list" [itemsList]="envases" [selectedItem]="porcionesForm.get('envase')" [placeHolder]="false"></app-filterable-list>
    </td>
    <td [ngClass]="{'show-error': showError}">
        <app-filterable-list class="shorter-list" [itemsList]="allDenominaciones" [selectedItem]="porcionesForm.get('denominacion')" [placeHolder]="false"></app-filterable-list>
    </td>
    <td [ngClass]="{'show-error': showError}">
        <input type="number" formControlName="kilos">
    </td>
    <td class="multi-actions">
        <ng-container *ngIf="editable">
            <i class="far fa-save" title="{{'titles.guardar' | translate}}" (click)="save()"></i>
            <i class="fas fa-times" title="{{'global.cancelar' | translate}}" (click)="cancel()"></i>
        </ng-container>
        <ng-container *ngIf="!editable">
            <i class="far fa-trash-alt" title="{{'titles.eliminar' | translate}}" (click)="remove()"></i>
        </ng-container>
    </td>
</ng-container>
